export const CourseContentCardQuestions = [
    {
        eventQuestionId: 0,
        eventId: 0,
        isMandatoryQuestion: true,
        eventQuestion: "The course material supported the course objectives.",
        eventQuestionTypeId: 2,
        isFeedbackQuestion: true,
        answers: [
            {
                "eventQuestionAnswerId": 0,
                "eventQuestionId": 0,
                "eventQuestionAnswer": "1. Strong Disagree",
                "isOther": false
            },
            {
                "eventQuestionAnswerId": 0,
                "eventQuestionId": 0,
                "eventQuestionAnswer": "2. Disagree",
                "isOther": false
            },
            {
                "eventQuestionAnswerId": 0,
                "eventQuestionId": 0,
                "eventQuestionAnswer": "3. Neutral",
                "isOther": false
            },
            {
                "eventQuestionAnswerId": 0,
                "eventQuestionId": 0,
                "eventQuestionAnswer": "4. Agree",
                "isOther": false
            },
            {
                "eventQuestionAnswerId": 0,
                "eventQuestionId": 0,
                "eventQuestionAnswer": "5. Strong Agree",
                "isOther": false
            },
        ],
        isOther: false,
    },
    {
        eventQuestionId: 0,
        eventId: 0,
        isMandatoryQuestion: true,
        eventQuestion: "The course material was clear, well organised and easy to follow.",
        eventQuestionTypeId: 2,
        isFeedbackQuestion: true,
        answers: [
            {
                "eventQuestionAnswerId": 0,
                "eventQuestionId": 0,
                "eventQuestionAnswer": "1. Strong Disagree",
                "isOther": false
            },
            {
                "eventQuestionAnswerId": 0,
                "eventQuestionId": 0,
                "eventQuestionAnswer": "2. Disagree",
                "isOther": false
            },
            {
                "eventQuestionAnswerId": 0,
                "eventQuestionId": 0,
                "eventQuestionAnswer": "3. Neutral",
                "isOther": false
            },
            {
                "eventQuestionAnswerId": 0,
                "eventQuestionId": 0,
                "eventQuestionAnswer": "4. Agree",
                "isOther": false
            },
            {
                "eventQuestionAnswerId": 0,
                "eventQuestionId": 0,
                "eventQuestionAnswer": "5. Strong Agree",
                "isOther": false
            },
        ],
        isOther: false,
    },
    {
        eventQuestionId: 0,
        eventId: 0,
        isMandatoryQuestion: true,
        eventQuestion: "The case studies and/or exercises were relevant and useful.",
        eventQuestionTypeId: 2,
        isFeedbackQuestion: true,
        answers: [
            {
                "eventQuestionAnswerId": 0,
                "eventQuestionId": 0,
                "eventQuestionAnswer": "1. Strong Disagree",
                "isOther": false
            },
            {
                "eventQuestionAnswerId": 0,
                "eventQuestionId": 0,
                "eventQuestionAnswer": "2. Disagree",
                "isOther": false
            },
            {
                "eventQuestionAnswerId": 0,
                "eventQuestionId": 0,
                "eventQuestionAnswer": "3. Neutral",
                "isOther": false
            },
            {
                "eventQuestionAnswerId": 0,
                "eventQuestionId": 0,
                "eventQuestionAnswer": "4. Agree",
                "isOther": false
            },
            {
                "eventQuestionAnswerId": 0,
                "eventQuestionId": 0,
                "eventQuestionAnswer": "5. Strong Agree",
                "isOther": false
            },
        ],
        isOther: false,
    },
    {
        eventQuestionId: 0,
        eventId: 0,
        isMandatoryQuestion: true,
        eventQuestion: "The amount of material presented in this course was just right.",
        eventQuestionTypeId: 2,
        isFeedbackQuestion: true,
        answers: [
            {
                "eventQuestionAnswerId": 0,
                "eventQuestionId": 0,
                "eventQuestionAnswer": "1. Strong Disagree",
                "isOther": false
            },
            {
                "eventQuestionAnswerId": 0,
                "eventQuestionId": 0,
                "eventQuestionAnswer": "2. Disagree",
                "isOther": false
            },
            {
                "eventQuestionAnswerId": 0,
                "eventQuestionId": 0,
                "eventQuestionAnswer": "3. Neutral",
                "isOther": false
            },
            {
                "eventQuestionAnswerId": 0,
                "eventQuestionId": 0,
                "eventQuestionAnswer": "4. Agree",
                "isOther": false
            },
            {
                "eventQuestionAnswerId": 0,
                "eventQuestionId": 0,
                "eventQuestionAnswer": "5. Strong Agree",
                "isOther": false
            },
        ],
        isOther: false,
    },
    {
        eventQuestionId: 0,
        eventId: 0,
        isMandatoryQuestion: true,
        eventQuestion: "The course increased my understanding of the topic.",
        eventQuestionTypeId: 2,
        isFeedbackQuestion: true,
        answers: [
            {
                "eventQuestionAnswerId": 0,
                "eventQuestionId": 0,
                "eventQuestionAnswer": "1. Strong Disagree",
                "isOther": false
            },
            {
                "eventQuestionAnswerId": 0,
                "eventQuestionId": 0,
                "eventQuestionAnswer": "2. Disagree",
                "isOther": false
            },
            {
                "eventQuestionAnswerId": 0,
                "eventQuestionId": 0,
                "eventQuestionAnswer": "3. Neutral",
                "isOther": false
            },
            {
                "eventQuestionAnswerId": 0,
                "eventQuestionId": 0,
                "eventQuestionAnswer": "4. Agree",
                "isOther": false
            },
            {
                "eventQuestionAnswerId": 0,
                "eventQuestionId": 0,
                "eventQuestionAnswer": "5. Strong Agree",
                "isOther": false
            },
        ],
        isOther: false,
    },
    {
        eventQuestionId: 0,
        eventId: 0,
        isMandatoryQuestion: true,
        eventQuestion: "The knowledge and skills gained will be useful to my work and/ or personal development.",
        eventQuestionTypeId: 2,
        isFeedbackQuestion: true,
        answers: [
            {
                "eventQuestionAnswerId": 0,
                "eventQuestionId": 0,
                "eventQuestionAnswer": "1. Strong Disagree",
                "isOther": false
            },
            {
                "eventQuestionAnswerId": 0,
                "eventQuestionId": 0,
                "eventQuestionAnswer": "2. Disagree",
                "isOther": false
            },
            {
                "eventQuestionAnswerId": 0,
                "eventQuestionId": 0,
                "eventQuestionAnswer": "3. Neutral",
                "isOther": false
            },
            {
                "eventQuestionAnswerId": 0,
                "eventQuestionId": 0,
                "eventQuestionAnswer": "4. Agree",
                "isOther": false
            },
            {
                "eventQuestionAnswerId": 0,
                "eventQuestionId": 0,
                "eventQuestionAnswer": "5. Strong Agree",
                "isOther": false
            },
        ],
        isOther: false,
    },
    {
        eventQuestionId: 0,
        eventId: 0,
        isMandatoryQuestion: false,
        eventQuestion: "What other comments/ suggestions do you have about the course material?",
        eventQuestionTypeId: 1,
        isFeedbackQuestion: true,
        answers: [],
        isOther: false,
    },
]